'use strict';

import React from 'react'
import ReactDOM from 'react-dom'
import templateData from '../utility/getTemplateData'

let PropTypes = React.PropTypes

export default React.createClass({

    getInitialState () {

		let logoUrl = templateData.bannerUrl || ''
        return {
            bannerUrl: logoUrl.includes('https') ? logoUrl : false
        };
    },

    render () {
        return (
        	<div className="row donate_banner_wrapper">
				<div className="col-xs-12 col-sm-12 col-md-12">
					<div className="banner_img_holder center-block">
						{this.state.bannerUrl ? <img id="charityLogo" src={this.state.bannerUrl} /> : null }
					</div>
				</div>
			</div>
        );
    }
});



// WEBPACK FOOTER //
// ./common/globalBanner.js